import {
    IB_ACCOUNT_RULES_FETCH,
    IB_ACCOUNT_RULES_IS_FETCING,
    IB_ACCOUNT_RULES_API,
    IB_ACCOUNT_RULE_EDIT,
    IB_ACCOUNT_RULE_FILTER,
    SET_IB_ACCOUNT_RULE_PROFILE,
    SET_IB_ACCOUNT_RULE_IB
} from 'constants/ibAccountRules'

//HTTP reuests actions
import {
    put,
    post,
    remove,
    get
} from 'actions/requests'

//Save Propfiles
export const ibAccountRuleSave = (data) => (dispatch, state) => {
    dispatch(ibAccountRulesIsFetching(true))
    return post(IB_ACCOUNT_RULES_API, data)
        .then((e) => { dispatch(ibAccountRulesIsFetching(false)); return e; })
        .catch((e) => { dispatch(ibAccountRulesIsFetching(false)); throw new Error(e) })
}

//Edit Propfiles
export const ibAccountRuleEditSave = (data) => (dispatch, state) => {
    dispatch(ibAccountRulesIsFetching(true))
    return put(IB_ACCOUNT_RULES_API, data)
        .then((e) => { dispatch(ibAccountRulesIsFetching(false)); return e; })
        .catch((e) => { dispatch(ibAccountRulesIsFetching(false)); throw new Error(e) })
}



//Feth ibAccountRule by id
export const ibAccountRuleFetch = (id) => (dispatch, state) => {
        dispatch(ibAccountRulesIsFetching(true));
        return get(IB_ACCOUNT_RULES_API + '/' + id)
            .then((e) => { dispatch(ibAccountRulesIsFetching(false)); return e; })
    }
    //Feth all ibAccountRules
export const ibAccountRulesFetch = (filters,loading=true) => (dispatch, state) => {
    /*dispatch(ibAccountRulesIsFetching(true));

    const filter = state().ibAccountRules.pageable.filter
    let api = Object.keys(filter).reduce((str, el) => str.replace('$' + el, filter[el]), IB_ACCOUNT_RULES_API);*/

    
    
    dispatch(ibAccountRulesIsFetching(loading));
    const filter = state().ibs.pageable
    const sorted = Object.keys(filter.sort).find(e => filter.sort[e])

    let params = {
            size: 1000000,
            page: filter.page,
            sort: sorted + ',' + filter.sort[sorted]
        }

    if (filters) {
        if(filters.hasOwnProperty('profileId')) {
            params.profileId = filters.profileId
        }
        if(filters.hasOwnProperty('ibId')) {
            params.ibId = filters.ibId
        }
    }

    return get(IB_ACCOUNT_RULES_API, params)


    //return get(api)

    //Array->Obj[ibAccountRuleId]{...ibAccountRuleinformation}
    //for easy access of ibAccountRule by his id
    .then((e) => {
            dispatch(ibAccountRulesFetched(e))
            return e
        })
        .then((e) => {
            dispatch(
                ibAccountRuleFilter({
                    totalPages: e.totalPages
                })
            )
            return e
        })
        //disable loading
        .then((e) => { dispatch(ibAccountRulesIsFetching(false)); return e; })
        .finally(e => dispatch(ibAccountRulesIsFetching(false)))
}

export const ibAccountRuleAvalableFetch = (data) => (dispatch) => {
	dispatch(ibAccountRulesIsFetching(true))

	return get(IB_ACCOUNT_RULES_API + '/available')
			.then((e) => {
					dispatch(ibAccountRulesFetched(e))
					return e
			})
			.finally(e => dispatch(ibAccountRulesIsFetching(false)))
}

//Remove one ibAccountRule
export const ibAccountRuleRemove = (ibId) => (dispatch, state) => {
    dispatch(ibAccountRulesIsFetching(true))
    return remove(IB_ACCOUNT_RULES_API + '/' + ibId)
        .then((e) => {
            dispatch(ibAccountRulesIsFetching(false));
            return e;
        })
}
export const ibAccountRulesFetched = (payload) => ({ type: IB_ACCOUNT_RULES_FETCH, payload: payload })
export const ibAccountRulesIsFetching = (payload) => ({ type: IB_ACCOUNT_RULES_IS_FETCING, payload: payload })
export const ibAccountRuleEdit = (id, data) => ({ type: IB_ACCOUNT_RULE_EDIT, payload: data })
export const ibAccountRuleFilter = (data) => ({ type: IB_ACCOUNT_RULE_FILTER, payload: data })
export const setIbAccountRuleProfile = (data) => ({ type: SET_IB_ACCOUNT_RULE_PROFILE, payload: data })
export const setIbAccountRuleIb = (data) => ({ type: SET_IB_ACCOUNT_RULE_IB, payload: data })


// WEBPACK FOOTER //
// ./src/actions/ibAccountRules.js